export enum TypeOfApplicationEnum {
  draft = "Draft",
  amendment = "Amendment",
  submit = "Submit",
  Acknowledge = "Acknowledge",
  cancel = "Cancellation",
  acknowledgement = "acknowledgement",
  submitresult = "submitresult",
  Duplicate = "Duplicate",
}

export enum ApplicationStatus {
  testingInprogress = "Testing In Progress",
  reportReleased = "Report Released",
  applicationClosed = "Application Closed",
  samplesreceived = "Sample(s) Received",
  ReportHardCopyCollected = "Report Hard Copy Collected",
}

export enum ApplicationTypeEnum {
  newApplication = 1,
  amendment	 = 2,
  Cancellation = 3,
  duplicateCopy = 4,
}
